import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "CartIcon"
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "viewBox": "0 0 22 19" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "d": "M17.316 17.33c0 .397-.14.735-.419 1.015-.279.279-.617.419-1.015.419-.398 0-.736-.14-1.016-.42a1.383 1.383 0 0 1-.419-1.015c0-.398.14-.74.42-1.028.279-.288.617-.432 1.015-.432.398 0 .736.144 1.015.432.28.288.42.63.42 1.028zm-8.658 0c0 .397-.14.735-.419 1.015-.279.279-.618.419-1.015.419-.398 0-.74-.14-1.029-.42a1.363 1.363 0 0 1-.431-1.015c0-.398.144-.74.431-1.028.288-.288.63-.432 1.029-.432.397 0 .736.144 1.015.432.28.288.42.63.42 1.028zM6.5 13h11.553c.203 0 .372.068.508.203a.689.689 0 0 1 .203.508.689.689 0 0 1-.203.508.689.689 0 0 1-.508.203H6.5c-.372 0-.71-.127-1.016-.381-.304-.254-.482-.559-.533-.914L3.021 1.549c-.033-.085-.076-.127-.126-.127H.71a.689.689 0 0 1-.508-.203A.689.689 0 0 1 0 .71C0 .508.068.339.203.203A.689.689 0 0 1 .711 0h2.184a1.5 1.5 0 0 1 1.002.38c.297.255.487.602.572 1.042H20.49c.423 0 .737.135.94.406.152.203.228.44.228.711a.655.655 0 0 1-.025.305L20.21 8.658a2.36 2.36 0 0 1-.482 1.016c-.237.288-.56.431-.965.431H5.89l.482 2.768c0 .085.042.127.127.127zm11.908-4.342c.068 0 .144-.034.229-.101.084-.068.127-.127.127-.178l1.37-5.51H4.698l.965 5.79h12.746z" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
const cartIcon = __component__.exports;
export {
  cartIcon as default
};
